import { render, staticRenderFns } from "./PhysicalCheck.vue?vue&type=template&id=71b887fe"
import script from "./PhysicalCheck.vue?vue&type=script&lang=js"
export * from "./PhysicalCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports